import { createReducer } from 'typesafe-actions';
import { StatamentAction } from '@store/actions';
import { clearStatementError, fetchStatementAsync } from '@store/actions/statements.action';
import { Documents, Statements } from '@types';

export interface StatementState {
    statements: Statements;
    lenderLoan: string;
    documents: Array<Documents>;
    loading: boolean;
}

export const statements: StatementState = {
    statements: {} as Statements,
    lenderLoan: '',
    documents: [],
    loading: false
};

export const statementReducer = createReducer<StatementState, StatamentAction>(statements)
    .handleAction(fetchStatementAsync.request, (state, action) => ({
        ...state,
        loading: true
    }))
    .handleAction(fetchStatementAsync.success, (state, action) => ({
        ...state,
        ...action.payload.response,
        loading: false
    }))
    .handleAction(fetchStatementAsync.failure, (state, action) => ({
        ...state,
        loading: false,
        lenderLoan: action.payload.loanNumber,
        statements: {
            errorDetails: action.payload.error
        }
    }))
    .handleAction(clearStatementError, (state, action) => ({
        ...state,
        statements: {
            errorDetails: undefined
        }
    }));
